<script>
  import { onMount } from "svelte";
  import { Email } from "@util/auth-firebase";
  import { getAuth } from "firebase/auth";
  import { user, ux } from "../../store";
  import { goto } from "../../util";
  import { pages } from "../../config";

  async function verify() {
    const auth = getAuth();
    const emailAuth = new Email(auth);
    emailAuth.responseUrl = window.location.href;

    localStorage.setItem("emailForSignIn", $ux.emailForSignIn);

    const [u, err] = await emailAuth.verifyLoginLink();
    console.log(u, err);
    return [u, err];
  }

  onMount(async () => {
    const [u, err] = await verify();
    if (u) {
      $user = u?.user;
      goto(pages.account.list.url);
    } else if (err) {
      if (err.code === "auth/invalid-action-code") {
        console.warn("USER_ALREADY_VERIFIED");
        goto(pages.account.list.url);
        return;
      }
      if (err.code === "auth/invalid-email") {
        alert(
          "Sorry, we do not know this email address. Please register first."
        );
        goto(pages.entry.welcome.url);
        return;
      }
      console.warn("USER_NOT_VERIFIED", err);
      // goto(pages.entry.url);
    } else {
      console.warn("EMPTY_USER");
    }
  });
</script>
